import * as React from "react";
import { Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { CircularProgress } from "@mui/material";

export const RHFAutocompleteMultiple = (
    props
) => {
    const { control, options, name, defaultValue, disabled, loading } = props;
    return (
        <Controller
            name={name}
            control={control}
            rules={{
                required: "this field is requried"
            }}
            render={({ field, fieldState: { error } }) => {
                const { onChange, value, ref } = field;
                return (
                    <>
                        <Autocomplete
                            disabled={disabled}
                            multiple
                            id="tags-standard"
                            options={options}
                            getOptionLabel={(option) => {
                                return option.label;
                            }}
                            defaultValue={defaultValue}
                            onChange={(event, newValue) => {
                                const resolvedId = newValue ? newValue : null;
                                onChange(resolvedId);
                                props.onChange?.(resolvedId);
                            }}
                            loading={loading}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={props.placeholder}
                                    inputRef={ref}
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    }}
                                />
                            )}
                            style={props.style}
                        />
                    </>
                );
            }}
        />
    );
};
